"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _Notifications = require("../../components/Notifications"),
    GENERIC_ERROR_MSG = "Try refreshing the page.";

function makeRequest() {
  return _makeRequest.apply(this, arguments);
}

function _makeRequest() {
  return _makeRequest = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(_ref) {
    var request, requestParams, showErrorNotification, _yield$request, data, errors, isError;

    return _regenerator["default"].wrap(function (_context) {
      for (;;) {
        switch (_context.prev = _context.next) {
          case 0:
            return request = _ref.request, requestParams = _ref.requestParams, showErrorNotification = _ref.showErrorNotification, _context.prev = 1, _context.next = 4, request(requestParams);

          case 4:
            return _yield$request = _context.sent, data = _yield$request.data, errors = _yield$request.errors, isError = errors && errors.length, isError && showErrorNotification && (0, _Notifications.notify)({
              type: "error",
              content: GENERIC_ERROR_MSG
            }), _context.abrupt("return", {
              data: data,
              error: isError ? GENERIC_ERROR_MSG : void 0
            });

          case 12:
            return _context.prev = 12, _context.t0 = _context["catch"](1), showErrorNotification && (0, _Notifications.notify)({
              type: "error",
              content: GENERIC_ERROR_MSG
            }), _context.abrupt("return", {
              error: GENERIC_ERROR_MSG
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  })), _makeRequest.apply(this, arguments);
}

var _default = makeRequest;
exports["default"] = _default;